import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';
const api={
    payment:oaserver+'payment',
    oacurrency:oaserver+'/oacurrency'
}

//列表
export async function getExcelTempList(params) {
    return post(api.payment+'/excel/getExcelTempList', params, true);
}
//详情
export async function getExcelTempDetails(params) {
    return post(api.payment+'/excel/getExcelTempDetails', params, true);
}
//新增
export async function addExcelTemp(params) {
    return post(api.payment+'/excel/addExcelTemp', params, true);
}
//编辑
export async function editExcelTemp(params) {
    return post(api.payment+'/excel/editExcelTemp', params, true);
}
//复制
export async function duplicateExcelTemp(params) {
    return post(api.payment+'/excel/duplicateExcelTemp', params, true);
}